var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconWhiteRound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "black",
    fillOpacity: 0.36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9398 16.0001L21.1398 11.8068C21.2653 11.6813 21.3359 11.511 21.3359 11.3335C21.3359 11.1559 21.2653 10.9857 21.1398 10.8601C21.0143 10.7346 20.844 10.6641 20.6665 10.6641C20.4889 10.6641 20.3187 10.7346 20.1931 10.8601L15.9998 15.0601L11.8065 10.8601C11.6809 10.7346 11.5107 10.6641 11.3331 10.6641C11.1556 10.6641 10.9853 10.7346 10.8598 10.8601C10.7343 10.9857 10.6637 11.1559 10.6637 11.3335C10.6637 11.511 10.7343 11.6813 10.8598 11.8068L15.0598 16.0001L10.8598 20.1935C10.7973 20.2554 10.7477 20.3292 10.7139 20.4104C10.68 20.4916 10.6626 20.5788 10.6626 20.6668C10.6626 20.7548 10.68 20.8419 10.7139 20.9232C10.7477 21.0044 10.7973 21.0781 10.8598 21.1401C10.9218 21.2026 10.9955 21.2522 11.0767 21.2861C11.158 21.3199 11.2451 21.3373 11.3331 21.3373C11.4211 21.3373 11.5083 21.3199 11.5895 21.2861C11.6708 21.2522 11.7445 21.2026 11.8065 21.1401L15.9998 16.9401L20.1931 21.1401C20.2551 21.2026 20.3288 21.2522 20.4101 21.2861C20.4913 21.3199 20.5785 21.3373 20.6665 21.3373C20.7545 21.3373 20.8416 21.3199 20.9228 21.2861C21.0041 21.2522 21.0778 21.2026 21.1398 21.1401C21.2023 21.0781 21.2519 21.0044 21.2857 20.9232C21.3196 20.8419 21.337 20.7548 21.337 20.6668C21.337 20.5788 21.3196 20.4916 21.2857 20.4104C21.2519 20.3292 21.2023 20.2554 21.1398 20.1935L16.9398 16.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconWhiteRound);
export default __webpack_public_path__ + "static/media/close-icon-white-round.59a1853f10334bf195e9ccba7e337b2e.svg";
export { ForwardRef as ReactComponent };